import * as React from 'react';

import {OnboardingChecklist as OnboardingChecklistShell} from 'shells/onboarding-checklist/onboarding-checklist';

import {appHistory} from '../../../history';
import {useDismissibleUserSetting} from '../../../util/hooks/use-dismissible-user-setting';

import {OpenableModals, useOpenableModal} from '../../openable-modals';

import {useGetOnboardingChecklist} from '../graphql/hooks/use-get-onboarding-checklist';

import {getOnboardingChecklistItems} from './helpers';

const HAS_DISMISSED_CHECKLIST = 'has_dismissed_signup_checklist';

export function OnboardingChecklist() {
    const {onboardingChecklist, completedCount, totalCount, checklistIsComplete} =
        useGetOnboardingChecklist();
    const {shouldShow, onDismiss} = useDismissibleUserSetting(HAS_DISMISSED_CHECKLIST);
    const {onOpen: onOpenInviteUsersModal} = useOpenableModal(OpenableModals.INVITE_USERS_MODAL);
    const {onOpen: onOpenImportModal} = useOpenableModal(OpenableModals.IMPORT_MODAL);

    if (
        !shouldShow ||
        !onboardingChecklist ||
        !onDismiss ||
        !onboardingChecklist.isAvailable ||
        (NutClientConfig.hasTrialExperience2026FF && NutClientConfig.loggedInUserIsAdmin)
    ) {
        return null;
    }

    const checklist = {
        ...onboardingChecklist,
        items: getOnboardingChecklistItems({
            items: onboardingChecklist.items,
            openInviteModal: onOpenInviteUsersModal,
            openImportModal: onOpenImportModal,
        }),
    } as const;

    return (
        <>
            <OnboardingChecklistShell
                checklist={checklist}
                onClose={onDismiss}
                // @ts-expect-error
                completedCount={completedCount}
                // @ts-expect-error
                totalCount={totalCount}
                // @ts-expect-error
                checklistIsComplete={checklistIsComplete}
                history={appHistory}
                hasCollapsedButton={true}
                title='Explore Nutshell Sales by starting with the basics'
            />
        </>
    );
}
